import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ManageViewAvailability } from './manage-view-availabilities.model';

export interface GenerateManageViewAvailabilityOptions {
  readonly id?: number;
  readonly seoUrl?: string;
  readonly origin?: string;
  readonly destinations?: readonly string[];
  readonly vehicleTypes?: string;
  readonly availableCapacity?: string;
  readonly minimumBudget?: number;
  readonly startDateMin?: number;
  readonly startDateMax?: number;
  readonly endDateMin?: number;
  readonly endDateMax?: number;
}

export function generateManageViewAvailabilityObject({
  id = generateId(),
  seoUrl = `Semi-trailer-truck-available-${id}`,
  origin = 'Sydney, NSW',
  destinations = [],
  vehicleTypes,
  availableCapacity,
  minimumBudget,
  startDateMin = Date.now(),
  startDateMax = Date.now(),
  endDateMin,
  endDateMax,
}: GenerateManageViewAvailabilityOptions = {}): ManageViewAvailability {
  return {
    id,
    seoUrl,
    origin,
    destinations,
    vehicleTypes,
    availableCapacity,
    minimumBudget,
    startDateMin,
    startDateMax,
    endDateMin,
    endDateMax,
  };
}
